import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { LeadInterface } from "@/interfaces/leadInterface";
import { IOfferValue } from "./offerSlice";
import { PaymentInterface } from "@/interfaces/PaymentInterface";
import { IUserValue } from "./userSlice";
import State from "@/types/utils/State";

export type Recaptcha = string | undefined

type ModalType = null | 'falha-pagamento' | 'generic-error' | 'email-ja-cadastrado' | 'pagamento-duplicado' | 'sumario' | 'impossibilidade' | 'atualizar-telefone' | 'usuario-assinante'

interface IModal{
    show: boolean
    type: ModalType
    email?: string
    bg?: string
}

interface IAppValue{
    loading: boolean
    index: number
    payment: number
    step: number
    recaptcha: Recaptcha
    modal: IModal
}

export interface IAllStates {
    app: State<IAppValue>
    lead: State<LeadInterface>
    offer: State<IOfferValue>
    payment: State<PaymentInterface>
    usuario: State<IUserValue>
}

const initialState: State<IAppValue> = {
    value: {
        loading: false,
        index: 0,
        payment: 0,
        step: 1,
        recaptcha: undefined,
        modal: {
            show: false,
            type: 'falha-pagamento'
        }
    },
}

export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        SET_RECAPTCHA: (state, {payload}: PayloadAction<Recaptcha>) => {
            state.value.recaptcha = payload
        },
        SET_USER_TAB: (state, action) => {
            const {payload} = action
            state.value.index = payload
        },
        SET_LOADING: (state, action: PayloadAction<boolean>) => {
            const {payload} = action
            state.value.loading = payload
        },
        SET_USER_STEP: (state, action: PayloadAction<number>) => {
            const {payload} = action
            state.value.step = payload
        },
        SET_PAYMENT_STEP: (state, action: PayloadAction<number>) => {
            const {payload} = action
            state.value.payment = payload
        },
        SET_MODAL: (state, action: PayloadAction<IModal>) => {
            const {payload} = action
            state.value.modal = payload
        }
    }
})

export const {SET_USER_TAB} = appSlice.actions
export const {SET_MODAL} = appSlice.actions
export const {SET_RECAPTCHA} = appSlice.actions
export const {SET_LOADING} = appSlice.actions
export const {SET_PAYMENT_STEP} = appSlice.actions
export const {SET_USER_STEP} = appSlice.actions
export const GET_USER_TAB = (state: any): number => state.app.value.index
export const GET_LOADING = (state: any): boolean => state.app.value.loading
export const GET_MODAL = (state: any) : IModal => state.app.value.modal
export const GET_USER_STEP = (state: any): number => state.app.value.step
export const GET_ALL_STATE = (state: any): IAllStates => state
export const GET_PAYMENT_STEP = (state: any): number => state.app.value.payment
export default appSlice.reducer
